/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteManagedContentParams,
  GetManagedContentParams,
  ManagedContent,
  ManagedContentInsertPayload,
  ManagedContentUpdate,
  PatchManagedContentParams,
  PostManagedContentParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getManagedContentResponse200 = {
  data: ManagedContent[]
  status: 200
}

export type getManagedContentResponse206 = {
  data: ManagedContent[]
  status: 206
}

export type getManagedContentResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getManagedContentResponseSuccess = (getManagedContentResponse200 | getManagedContentResponse206) & {
  headers: Headers;
};
export type getManagedContentResponseError = (getManagedContentResponseDefault) & {
  headers: Headers;
};

export type getManagedContentResponse = (getManagedContentResponseSuccess | getManagedContentResponseError)

export const getGetManagedContentUrl = (params?: GetManagedContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/managed_content?${stringifiedParams}` : `${backendBaseUrl}/managed_content`
}

/**
 * @summary Read rows from `managed_content`.
 */
export const getManagedContent = async (params?: GetManagedContentParams, options?: RequestInit): Promise<getManagedContentResponse> => {

  const res = await fetch(getGetManagedContentUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getManagedContentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getManagedContentResponse
}


export type postManagedContentResponse201 = {
  data: ManagedContent[]
  status: 201
}

export type postManagedContentResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postManagedContentResponseSuccess = (postManagedContentResponse201) & {
  headers: Headers;
};
export type postManagedContentResponseError = (postManagedContentResponseDefault) & {
  headers: Headers;
};

export type postManagedContentResponse = (postManagedContentResponseSuccess | postManagedContentResponseError)

export const getPostManagedContentUrl = (params?: PostManagedContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/managed_content?${stringifiedParams}` : `${backendBaseUrl}/managed_content`
}

/**
 * @summary Insert one or more rows into `managed_content`.
 */
export const postManagedContent = async (managedContentInsertPayload: ManagedContentInsertPayload,
    params?: PostManagedContentParams, options?: RequestInit): Promise<postManagedContentResponse> => {

  const res = await fetch(getPostManagedContentUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(managedContentInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postManagedContentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postManagedContentResponse
}


export type patchManagedContentResponse200 = {
  data: ManagedContent[]
  status: 200
}

export type patchManagedContentResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchManagedContentResponseSuccess = (patchManagedContentResponse200) & {
  headers: Headers;
};
export type patchManagedContentResponseError = (patchManagedContentResponseDefault) & {
  headers: Headers;
};

export type patchManagedContentResponse = (patchManagedContentResponseSuccess | patchManagedContentResponseError)

export const getPatchManagedContentUrl = (params?: PatchManagedContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/managed_content?${stringifiedParams}` : `${backendBaseUrl}/managed_content`
}

/**
 * @summary Update the rows of `managed_content` matching the given filters.
 */
export const patchManagedContent = async (managedContentUpdate: ManagedContentUpdate,
    params?: PatchManagedContentParams, options?: RequestInit): Promise<patchManagedContentResponse> => {

  const res = await fetch(getPatchManagedContentUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(managedContentUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchManagedContentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchManagedContentResponse
}


export type deleteManagedContentResponse200 = {
  data: ManagedContent[]
  status: 200
}

export type deleteManagedContentResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteManagedContentResponseSuccess = (deleteManagedContentResponse200) & {
  headers: Headers;
};
export type deleteManagedContentResponseError = (deleteManagedContentResponseDefault) & {
  headers: Headers;
};

export type deleteManagedContentResponse = (deleteManagedContentResponseSuccess | deleteManagedContentResponseError)

export const getDeleteManagedContentUrl = (params?: DeleteManagedContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/managed_content?${stringifiedParams}` : `${backendBaseUrl}/managed_content`
}

/**
 * @summary Delete the rows of `managed_content` matching the given filters.
 */
export const deleteManagedContent = async (params?: DeleteManagedContentParams, options?: RequestInit): Promise<deleteManagedContentResponse> => {

  const res = await fetch(getDeleteManagedContentUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteManagedContentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteManagedContentResponse
}


